<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-4 service-img">
                <div class="img-lines-container">
                    <img class="mg-responsive service-img" :src="img" :alt="title">
                    <div class="img-lines"></div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <h4 class="card-title">{{title}}</h4>
                    <p><strong>{{subtitle}}</strong></p>
                    <hr>
                    <span class="card-text">{{text}}</span>
                    <div v-if="listItems && listItems.length > 0">
                        <p v-for="(listItem, index) in listItems" :key="index">{{listItem.text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Fact',
        props: {
            img: String,
            title: String,
            subtitle: String,
            text: String,
            listItems: Array,
            index: Number
        }
    }
</script>
<style scoped>
    hr {
        margin-top: -0.5rem;
        margin-bottom: 0.5rem;
    }
    
    @media (min-width: 768px) {
        hr {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
        .img-lines-container {
            min-height: 100%;
        }
        .service-img {
            max-height: 200%;
            max-width: 200%;
        }
        .img-lines-container .mg-responsive.service-img {
            height: 100%;
            max-width: initial;
            position:absolute;
            object-fit: cover;
            width: 100%; /* This causes stretching in IE */
        }
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        .img-lines-container .mg-responsive.service-img {
            width: auto; /* This fixes stretching in IE, but will not be centered */
        }
    }
    @media (min-width: 1200px) {
        hr {
            margin-top: 0.5rem;
            margin-bottom: 1rem;
        }
    }
    .img-lines-container {
        max-height: 300px;
    }
    .card {
        flex: 0 0 100%;
        margin-bottom: 15px;
    }
</style>